import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=c48cec1e"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3276139710/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c48cec1e')) {
      api.createRecord('c48cec1e', component.options)
    } else {
      api.reload('c48cec1e', component.options)
    }
    module.hot.accept("./Landing.vue?vue&type=template&id=c48cec1e", function () {
      api.rerender('c48cec1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layouts/Landing.vue"
export default component.exports